import RequestService from '../../../services/request-service';
import { LAYOUT_NAME } from '../../../models/enums/layout-const';

/**
 * Tournament Matches Request Service
 */
export class TournamentMatchesListRequestService extends RequestService {
  /**
   * Class constructor method
   */
  constructor() {
    super();
    this.endpoint = this.$config.endpoints.categoryMatchesList;
    this.method = 'get';
    const { Culture } = this.$config.defaultHeaders;
    this.getParams = {
      Culture: Culture,
      SportData: [],
      CategoryData: [],
      CategoryGroupData: [],
      TournamentData: [],
      TournamentGroupData: [],
      TimeFilter: 0,
      NumberOfOddTypes: 4, // default is 4
      isMultiMarket: APP_SETTINGS.settings.layout === LAYOUT_NAME.US,
    };
    this.headers = null;
  }
}

/**Sport Tabs service */
export class SportTabsService {
  static tabs = [
    { id: 1, key: 'competitions', value: 'Mobile.Tournaments' },
    { id: 2, key: 'livenow', value: 'Mobile.LiveNow' },
    { id: 3, key: 'boosted', value: 'BO.BoostedOdd' },
    { id: 4, key: 'highlights', value: 'Mobile.Highlights' },
  ];

  static getOrderedSportTabs() {
    let sportTabs = APP_SETTINGS.settings.sportTabs;
    if (typeof sportTabs === 'undefined' || sportTabs === '') {
      return this.tabs;
    }
    const tabKeys = sportTabs.split(',');
    return tabKeys.map(key => this.tabs.find(tab => tab.key === key.trim())).filter(t => t);
  }
}